import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';

import { IconButton2 } from '@clatter/ui';
import { StyledNotification } from '../StyledNotification';
import { CircularProgressWithLabel } from '../CircularProgressWithLabel/CircularProgressWithLabel';

interface Props {
  notification: ILongPullUIItem;
  onClose: (data: any) => void;
}

export const NgNotification: FC<Props> = ({ notification, onClose }) => {
  return (
    <StyledNotification key={notification.id} className={notification.type}>
      <span>{notification.message}</span>

      {notification.isLongpull &&
        (!notification.isCompleted ? <CircularProgress /> : <CircularProgressWithLabel value={100} />)}

      {/*@ts-ignore*/}
      <IconButton2
        onClick={() => {
          if (typeof onClose === 'function') {
            onClose(notification);
          }
        }}
        testId="CloseButton"
        disabled={notification.isLongpull && !notification.isCompleted}
      >
        <CloseIcon />
      </IconButton2>
    </StyledNotification>
  );
};
